<template>
  <div>
    <b-card-code
      title="Project List"
      no-body
    >
      <b-form-group
        label="Filter"
        label-cols-sm="3"
        label-align-sm="right"
        label-size="sm"
        label-for="filterInput"
        class="mb-0"
        style="width: 350px; position: absolute;  right: 10px; top: 17px;align-items: center;"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="Type to Search"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-table
        id="projectsTable"
        :fields="fields"
        :items="fProjects"
        responsive
        class="mb-0"
        hover
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
        :busy="isBusy"
      >
      <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
             
            </div>
          </template>
        <!-- A virtual column -->
        <template
          #cell(id)="data"
        >
          {{ data.value }}
        </template>

        <!-- A custom formatted column -->
        <template #cell(name)="data">
          <span class="text-nowrap">{{ data.value }}</span>
        </template>

        <template #cell(tags)="data">
          <b-badge
            v-for="(item) in data.value"
            :key="item"
            style="margin-right: 2px;font-size: 10px!important;font-weight: 100!important;"
          >{{ item }}</b-badge>
        </template>
        <!-- A custom formatted column -->
        <template #cell(status)="data">
          <svg
            v-for="(item, index) in task(data.value)"
            :key="index"
            v-b-tooltip.hover.top="item.tooltip"
            height="30"
            width="30"
            class="statusCircle"
          >
            <circle
              cx="15"
              cy="15"
              r="15"
              stroke="#fff"
              stroke-width="5"
              :fill="item.color"
            />
          </svg>
        </template>

        <template #cell(date)="data">
          {{ data.value }}
        </template>

        <template
          #cell(delete)="data"
          style="text-align:center"
        >
          <b-button
            v-show="isAdmin"
            variant="gradient-success"
            class="btn-icon rounded mr-1"
            size="sm"
            @click="editProject(data.value)"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button
           v-show="isAdmin"
            variant="gradient-danger"
            class="btn-icon rounded"
            size="sm"
            @click="deleteProject(data.value)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </template>

      </b-table>
    </b-card-code>
    <b-button
      v-show="isAdmin == true && isBusy == false"
      variant="gradient-primary"
      class="rounded btn-floating"
      size="md"
      @click="openForm()"
    >
      ADD NEW PROJECT
    </b-button>
  </div>
</template>

<script>
import Vue from 'vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BButton, VBTooltip, BBadge, BInputGroup, BFormInput, BInputGroupAppend, BFormGroup, BSpinner
} from 'bootstrap-vue'
import axios from 'axios'
import store from '@/store/index'
import NewProject from './NewProject.vue'

export default {
  components: {
    BCardCode,
    BSpinner,
    BTable,
    BButton,
    BBadge,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BFormGroup,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID', sortable: false },
        { key: 'name', label: 'Name', sortable: true },
        { key: 'Owner', label: 'Owner', sortable: true },
        { key: 'tags', label: 'Tags', sortable: false },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'date', label: 'Created At', sortable: true },
        { key: 'delete', label: '', sortable: false },
      ],
      projects: [],
      taskStatus: {},
      tags: [],
      filter: '',
      mFilter: null,
      tKey: 'table_0',
      isBusy:true,
      timer:null,
      isAdmin:0
    }
  },
  computed: {
    fProjects() {
      if (this.filter !== '') {
        console.log(`FILTERING: ${this.filter}`)
        return this.projects.filter(item => (item.name.toLowerCase().includes(this.filter.toLowerCase()) || item.tags.join(',').toLowerCase().includes(this.filter.toLowerCase()) || item.Owner.toLowerCase().includes(this.filter.toLowerCase())))
      }
      return this.projects
    },
  },
 
  created() {
    this.setData()
    store.commit('isProject', false)
    this.checkAdmin()
    this.timer = setInterval(() => {
      this.checkAdmin()
   
   }, 1000)
    
   
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  

  methods: {
    checkAdmin(){
      
      
      if(this.$store.state.user.userdata != undefined){
        this.isAdmin =  this.$store.state.user.userdata.admin 
        console.log("DIFERENT", this.$store.state.user.userdata)
        clearInterval(this.timer)
      }
      else{
        this.isAdmin = 0
      }
  

    },
    setData() {
      console.log("ASK FOR PROJECT")
      store.commit('title', 'PROJECTS')
      store.commit('icon', 'GridIcon')
      const { url, port, auth } = store.state.appConfig.api
      const headers = {
        authentication: auth,
        token: localStorage.getItem('sessionToken'),
        'Content-Type': 'application/json',
      }
      const data = []
      const dataStatus = {}
      // console.log('PROJECTS')
      this.$http.get(`${url}:${port}/projects`, { headers })
        .then(response => {
          console.log("PROJECT ANSWER")
          // console.log(response)
          response.data.data.forEach(element => {
            // console.log(element.status)
            dataStatus[element.id] = { running: false, paused: false, completed: false }
            const tags = (element.tags === null) ? [] : (element.tags).split(',')
            data.push({
              id: element.id,
              name: element.name,
              Owner: (`${element.owner_name} ${element.owner_lastname}`).trim(),
              date: this.$moment(element.created_at).tz('Europe/Helsinki').format('YYYY/MM/DD HH:mm:ss'),
              delete: element.id,
              status: element.status,
              visibility: element.visibility,
              tags,
              description: element.description,
            })
          })
          this.projects = data
          console.log("PROJECT FINISH")
          this.taskStatus = dataStatus
          this.tags = response.data.tags
          this.isBusy = false;
        })
    },
    task(status) {
      const data = []
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < status.queue.length; index++) {
        const element = status.queue[index]
        const json = JSON.parse(element.json)
        const taskJson = (status.task !== null) ? JSON.parse(status.task.json) : { task_type: 0 }
        const item = {}
        item.tooltip = json.task_type
        if (json.task_type === taskJson.task_type) {
          item.color = '#ff9f43'
          item.tooltip += ' - Processing'
          // this.dataStatus[id].running = true
        } else {
          if (element.done === 3) {
            item.color = '#ea5455'
            item.tooltip += ' - Disabled'
          }
          if (element.done === 1) {
            item.color = '#28c76f'
            item.tooltip += ' - Done'
          }
          if (element.done === 0) {
            item.color = '#fff4e9'
            item.tooltip += ' - Pending'
          }
        }
        data.push(item)
      }
      return data
    },
    onRowSelected(item) {
      this.$router.replace(`projects/${item[0].id}`)
      
    },
    openForm() {
      const projectForm = new Vue({
        ...NewProject,
        parent: this,
        propsData: { optionTags: this.tags },
      }).$mount()
      this.$swal({
        title: '<span class="font-weight-bolder">New Project</span>',
        html: projectForm.$el,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
      })
    },
    editProject(id) {
      const data = this.projects.find(item => item.id === id)
      const projectForm = new Vue({
        ...NewProject,
        parent: this,
        propsData: { projectId: id, data, optionTags: this.tags },
      }).$mount()
      this.$swal({
        title: '<span class="font-weight-bolder">Edit Project</span>',
        html: projectForm.$el,
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
      })
    },
    deleteProject(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const { url, port, auth } = store.state.appConfig.api
          const headers = {
            authentication: auth,
            'Content-Type': 'application/json',
          }
          axios.delete(`${url}:${port}/project/${id}`, { headers }).then(() => {
            this.$swal({
              icon: 'success',
              title: 'Deleted!',
              text: 'Process has been deleted.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            }).then(() => {
              this.setData()
            })
          })
        }
      })
    },
  },
}
</script>

<style>
 #projectsTable thead tr th:nth-child(1){
  width: 5%!important;
}
 #projectsTable thead tr th:nth-child(2){
  width: 15%!important;
}
 #projectsTable thead tr th:nth-child(3){
  width: 12%!important;
}
 #projectsTable thead tr th:nth-child(4){
  width: 15%!important;
}
 #projectsTable thead tr th:nth-child(5){
  width: 28%!important;
}
 #projectsTable thead tr th:nth-child(6){
  width: 15%!important;
}
 #projectsTable thead tr th:nth-child(7){
  width: 15%!important;
}
#projectsTable .spinner-border {
    display: inline-block;
    margin-top:20px;
    margin-bottom: 20px;
    color: #008380;
    width: 10rem;
    height: 10rem;
    vertical-align: text-bottom;
    font-size: 20px;
    animation: 0.9s linear infinite spinner-border-ltr;
}
.pill{
    width: 20px!important;
    margin-right: 10px!important;
    height: 20px!important;
}
.btn-floating{
  position: fixed;
  z-index: 0;
  bottom: 25px;
  right: 25px;
  width: auto;
  height: 50px;
  padding: 0px 25px;
}
.btn-floating svg{
  width: 20px;
  height: 20px;
  margin: 0px 10px 2px 0px;
}
.statusCircle{
  margin-right: -10px;
  border-radius: 20px;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
